import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa';

const languages = [
  { code: 'en', label: 'English', flag: '/assets/images/header/us_flag.png' },
  { code: 'fr', label: 'Français', flag: '/assets/images/header/french_flag.png' },
  { code: 'ru', label: 'Русский', flag: '/assets/images/header/russion_flag.png' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 transition border border-gray-300"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <img src={currentLang.flag} alt={currentLang.label} className="w-5 h-5 object-cover rounded-[100%]" />
        <span className="text-sm font-medium text-gray-700 hidden sm:inline">{currentLang.label}</span>
        <FaChevronDown className={`text-xs text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg border border-gray-200 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-gray-50 transition first:rounded-t-md last:rounded-b-md ${
                i18n.language === lang.code ? 'bg-yellow-50 text-yellow-600 font-medium' : 'text-gray-700'
              }`}
            >
              <img src={lang.flag} alt={lang.label} className="w-5 h-5 object-cover rounded-[100%]" />
              <span className="text-sm">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;